import yup from '../../../config/yup';

export const jdbcReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('jdbcReader'),
  delayedRead: yup.boolean(),
  parameterizedBy: yup.string(),
  properties: yup.object().shape({
    databaseName: yup.string().required('Database Name is required'),
    driver: yup.string().required('Driver is required'),
    sqlQuery: yup.string().required('SQL Query is required'),
    host: yup.string().required('Host is required'),
    port: yup.number().typeError('Port must be a number'),
    username: yup.string().required('Username is required'),
    password: yup.string().required('Password is required'),
  }),
});
